import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import { AllProviders } from './components/all-providers.tsx'
import { useAuth } from './components/providers/auth-provider.tsx'
import reportWebVitals from './reportWebVitals.ts'
import './styles.css'

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    auth: undefined,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// https://tanstack.com/router/latest/docs/framework/react/examples/authenticated-routes (context)
// then we do createRootLayoutWithContext inside __root.tsx
function InnerApp() {
  const auth = useAuth()
  return <RouterProvider router={router} context={{ auth }} />
}

function App() {
  let gitHashShort = import.meta.env.VITE_GIT_COMMIT_HASH ?? ''
  gitHashShort = gitHashShort.substring(0, 7)
  console.log({
    gitHashShort,
  })
  return (
    <AllProviders>
      <InnerApp />
    </AllProviders>
  )
}

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      {/* <RouterProvider router={router} context={{ auth }} /> */}
      <App />
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
